<template>
  <div class="client_request_deactivation">
    <div class="header">
      <h4 class="title">
        {{ translate("client_request.deactivation")}}
      </h4>
    </div>
    <div class="content">

      <div class="row">
        <WrapDatePicker
            class="col-md-6"
            type="date"
            value_type="YYYY-MM-DD"
            v-model="deactivate_data.date"
            :range="false"
            label="Запланированная дата деактивации"
            :clearable="false"
            :disabled_date="['- 1 month', '+ 1 month']"
        />
      </div>

      <div class="row text_wrap">
        <div class="col-md-12">
          <p>{{ text }}</p>
        </div>
      </div>
    </div>

    <div class="footer">
      <span
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="deactivate"
      >
        {{ translate('btn.deactivate') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: "ClientRequestDeviceDeactivation",
  components: {
    WrapDatePicker
  },
  props: [
    "device_id",
    "text"
  ],
  data () {
    return {
      deactivate_data: {
        date: null,
      },
    }
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    deactivate(){
      this.$http.v1.deactivationDeviceClientRequest({...this.deactivate_data, device_id: this.device_id}, () => {
        this.global_notify("info", this.translate("client_request.saved_success"));
        this.$emit('update')
      })
    }
  }
}

</script>

<style lang='scss' scoped>
  .client_request_deactivation{
    padding: 10px;
    .header{
      padding: 10px 0;
      .title{
        font-size: 22px;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
    }
    .content{
      padding: 10px 0;
      .wrap_datepicker{
        margin-bottom: 10px;
      }
      .text_wrap{
        p{
          font-size: 14px;
          text-align: center;
        }
      }

    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
        display: block;
      }
    }
  }

</style>
